export const SALES_ORDER_LIST = 'SALES_ORDER_LIST';

